import Style from "./BlocksTableStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import api from "../../../services/api";
import { FaTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";


export default function BlocksTable(props) {
  const [enterpriseBlocks, setEnterpriseBlocks] = useState([] as any);
  const [enterpriseBlock, setEnterpriseBlock] = useState({} as any);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [showPopUpDelete, setShowPopUpDelete] = useState(false);

  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    setLoading(true);
    LoadBlocks().then(() => {
      setLoading(false);
    });
  }, []);

  async function LoadBlocks() {
    try {
      setLoading(true)
      const result = await api.get(`/enterprises/${enterpriseId}/blocks`);
      setEnterpriseBlocks(result.data.blocks);
      setLoading(false);
    }
    catch (error: any) {
      setLoading(false)
      setMessage({ success: "", error: error?.response?.data?.message })
    }
  }
  async function onDelete() {
    setLoading(true);
    try {
      const result = await api.delete(`/enterprises/${enterpriseId}/blocks/${enterpriseBlock.id}`);
      if (result.data.success) {
        setMessage({ success: "Bloco deletado com sucesso!", error: "" });
        await LoadBlocks();
        setLoading(false);
        onClosePopUp();
      } else {
        setMessage({ success: "", error: "Problema ao deletar o bloco: " + result.data });
        setLoading(false);
        onClosePopUp();
      }
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
    }

  }
  function onOpenPopUp(block) {
    setEnterpriseBlock(block);
    setShowPopUpDelete(true);
  }
  function onClosePopUp() {
    setShowPopUpDelete(false)
  }

  function onBlockDetail(blockId) {
    props.history.push(`/enterprises/${enterpriseId}/blocks/${blockId}`)
  }


  return (
    <Style>
      <TwoButtonsModal
        show={showPopUpDelete}
        onHide={onClosePopUp}
        loading={loading}
        title="Deleção de bloco!"
        body={`Você está tentando deletar o bloco "${enterpriseBlock.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopUp}
        secondaryDisabled={loading}
        primaryText="Deletar"
        primaryOnClick={onDelete}
        primaryDisabled={loading}
      />
      <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Blocos</h1>
        <button onClick={() => props.history.push(`/enterprises/${enterpriseId}/blocks/0`)}>Adicionar Bloco</button>
      </section>
      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}
      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Nome</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {enterpriseBlocks.length > 0 && enterpriseBlocks.map(block => {
            return (
              <tr key={block.id} >
                <td onClick={() => onBlockDetail(block.id)}>{block.name}</td>
                <td className="action">
                  <button onClick={() => onOpenPopUp(block)}><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}